/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeOnboardingDetails } from './ChallengeOnboardingDetails';
import {
    ChallengeOnboardingDetailsFromJSON,
    ChallengeOnboardingDetailsFromJSONTyped,
    ChallengeOnboardingDetailsToJSON,
    ChallengeOnboardingDetailsToJSONTyped,
} from './ChallengeOnboardingDetails';

/**
 * Represents the onboarding details for a brand map challenge.
 * @export
 * @interface ChallengeOnboarding
 */
export interface ChallengeOnboarding {
    /**
     * 
     * @type {string}
     * @memberof ChallengeOnboarding
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeOnboarding
     */
    description: string;
    /**
     * 
     * @type {Array<ChallengeOnboardingDetails>}
     * @memberof ChallengeOnboarding
     */
    getStartedSteps?: Array<ChallengeOnboardingDetails>;
    /**
     * 
     * @type {ChallengeOnboardingDetails}
     * @memberof ChallengeOnboarding
     */
    instantReward?: ChallengeOnboardingDetails;
    /**
     * 
     * @type {ChallengeOnboardingDetails}
     * @memberof ChallengeOnboarding
     */
    prizePool?: ChallengeOnboardingDetails;
}

/**
 * Check if a given object implements the ChallengeOnboarding interface.
 */
export function instanceOfChallengeOnboarding(value: object): value is ChallengeOnboarding {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ChallengeOnboardingFromJSON(json: any): ChallengeOnboarding {
    return ChallengeOnboardingFromJSONTyped(json, false);
}

export function ChallengeOnboardingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeOnboarding {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
        'getStartedSteps': json['getStartedSteps'] == null ? undefined : ((json['getStartedSteps'] as Array<any>).map(ChallengeOnboardingDetailsFromJSON)),
        'instantReward': json['instantReward'] == null ? undefined : ChallengeOnboardingDetailsFromJSON(json['instantReward']),
        'prizePool': json['prizePool'] == null ? undefined : ChallengeOnboardingDetailsFromJSON(json['prizePool']),
    };
}

export function ChallengeOnboardingToJSON(json: any): ChallengeOnboarding {
    return ChallengeOnboardingToJSONTyped(json, false);
}

export function ChallengeOnboardingToJSONTyped(value?: ChallengeOnboarding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'getStartedSteps': value['getStartedSteps'] == null ? undefined : ((value['getStartedSteps'] as Array<any>).map(ChallengeOnboardingDetailsToJSON)),
        'instantReward': ChallengeOnboardingDetailsToJSON(value['instantReward']),
        'prizePool': ChallengeOnboardingDetailsToJSON(value['prizePool']),
    };
}

